export default {
    enabled: false,
    stateVersion: -1,
    assignment: null,
}
